import { createRoute } from "@tanstack/react-router";
import { LoginForm } from "@/components/auth/LoginForm";
import { Route as RootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: "/login",
  component: LoginRoute,
});

function LoginRoute() {
  return <LoginForm />;
}
